export default __webpack_public_path__ + "static/media/IdCard.443fdf67.png";